import React from "react";
import './Header.css';

function Header({heading,subheading1,subheading2,subheading3}){
    return(
        <div className="header">
            <h1 className="Heading1">
                {heading}
            </h1>
            <p className="Para1">
                {subheading1}
            </p>
            <p className="Para1">
                {subheading2}
            </p>
            {subheading3 && (
                <p className="Para1">
                    {subheading3}
                </p>
            )}
        </div>
    )
}
export default Header;